import React, { useEffect, useState } from 'react'
import styles from "../Corpus/corpus.module.css"
import { axiosInstance } from '../../Helpers/axiosInstance'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import "../../App.css"
import CustomSelect from '../../Components/CustomSelect'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import UnitStyles from "../MilUnit/MilUnit.module.css"
import 'react-toastify/dist/ReactToastify.css'
import MillUnitList from '../../Components/MilUnitList'

export default function Company() {
    const [company, setCompany] = useState("")
    const [companies, setCompanies] = useState([])
    const [milUnits, setMilUnits] = useState([])
    const [mil, setMil] = useState("")
    const [battalions,setBattalions] = useState([])
    const [bat, setBat] = useState("")
    const [change, setChange] = useState(null)
    const [clear, setClear] = useState(false)
    const [loading, setLoading] = useState(false)
    const [corpuses, setCorpuses] = useState([])
    const [corpusNum, setCorpusNum] = useState()
    const [isMillUnitShown, setMillUNitShown] = useState(false)
    const [search, setSearch] = useState("")

    useEffect(() => {
            (async() => {
                const corpuses = await axiosInstance.get('admin/corpuses')
                if(corpuses.status){
                    setCorpuses(corpuses.data.data)

                }
            })()
        }, [])

    useEffect(() => {
        (async() => {
            const milunits = await axiosInstance.get('admin/milunits')
            if(milunits.status){
                setMilUnits(milunits.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        (async() => {
            const batalions = await axiosInstance.get(`admin/battalions/${typeof mil === "object" ? mil._id : mil}`)
            if(batalions.status){
                setBattalions(batalions.data.data)
            }
        })()
        if(typeof bat !== "object"){
            setBat("")
        }
       }, [mil])

       useEffect(() => {
        (async() => {
            const companies = await axiosInstance.get(`admin/companies`)
            if(companies.status){
             setCompanies(companies.data.data)
            }
        })()
    }, [])


    const submitHandler = async () => {
        if(!company){
            toast.error("Վաշտի համար/անվանում դաշտը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.post('admin/company', {company_number: company, company_unit: mil ? mil : null, company_battalion: bat ? bat : null})
        if(res.data.status){
            setMil("")
            setBat("")
            setCompany("")
            setCompanies([...companies, res.data.data])
            toast.success("Վաշտը հաջողությամբ ավելացվեց");
            setClear(true)
            setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }

    const chnageCompany = async (el) => {
        setChange(el)
        setCompany(el.company_number)
        setMil(el.company_unit)
        setBat(el.company_battalion)
    }

    const deleteCompany = async (el) => {
        const res = await axiosInstance.delete(`admin/company/${el._id}`)
        if(res.data.status){
            setCompanies(p => p.filter(c => c._id !== el._id))
            toast.success("Վաշտը հաջողությամբ ջնջվեց");
        }
    }   

    const changeHandler = async () => {
        if(!company){
            toast.error("Վաշտի համար/անվանում դաշտը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.put(`admin/company/${change._id}`, {company_number: company, company_unit: mil ? mil : null, company_battalion: bat ? bat : null})
        if(res.data.status){
            setChange(null)
            setCompanies(p => {
                let index = companies.findIndex(el => el._id === change._id)
                const newCorpuses = [...companies]
                newCorpuses[index] = {...res.data.data}
                return newCorpuses
            })
            setCompany("")
            toast.success("Վաշտը հաջողությամբ փոփոխվեց");
                setClear(true)
                setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }


  return (
    <div className={styles["corpus-main-div"]}>
        <div className={styles["corpus-container"]}>
            <h2>Լրացրեք վաշտի տվյալները</h2>
             <div>
                <label htmlFor="corpusNumber">Վաշտի համար/անվանում</label>
                <input type="text" id="corpusNumber" value={company} onChange={(e) => setCompany(e.target.value)} />
            </div>
            <div>
                <CustomSelect 
                    defaultValueForInput={mil ? mil.unit_number : ''}
                    options={milUnits?.map((el,i) => <option key={i} value={el._id}>{el.unit_number}</option>)}
                    callback={setMil}
                    label="Ընտրել զորամասը"
                    clear={clear}
                />
            </div>
            <div className='my-[20px]'>
                <CustomSelect 
                    defaultValueForInput={bat ? bat.battalion_number : ''}
                    options={battalions?.map((el,i) => <option key={i} value={el._id}>{el.battalion_number}</option>)}
                    callback={setBat}
                    label="Ընտրել գումարտակը"
                    clear={clear}
                />
            </div>
           
            <button className={`confirm-btn`} disabled={loading} onClick={() => change ? changeHandler() : submitHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
        </div>
        <div className={styles["corpus-list"]}>
            <div className='relative'>
                <h2>Վաշտեր</h2>
                <input type="text" placeholder='Փնտրել...' className="absolute border border-black/40 p-1 rounded-md top-0 left-4" onChange={(e) => setSearch(e.target.value)}/>
            </div>
            {!search ? corpuses.map((el, index) => {
                return (
                    <li key={index} className={UnitStyles["corpus-list-items"]}>
                        <p className='text-center cursor-pointer' onClick={() => {setCorpusNum(el._id);setMillUNitShown(!isMillUnitShown)}}>{el?.corpus_number + " " + el?.corpus_name}</p>
                        {isMillUnitShown && corpusNum === el._id  && <MillUnitList millUnits={milUnits} corpusNumber={el?._id} companies={companies} changeMilUnit={chnageCompany} deleteBattalion={deleteCompany} />}
                    </li>
                )
            }) : <ol onClick={e => e.stopPropagation()}>
                <li className={styles["corpus-list-item"]}>
                    <p className='per4 start'>Վաշտի համար</p>
                    <p className='per4'>Զորամաս</p>
                    <p className='per4'>Գումարտակ</p>
                    <p className='per4 end'>Ղեկավարման կոճակներ</p>
                </li>
                {companies?.filter(el => el?.company_number?.includes(search)).map((el, index) => {
                    return <li key={index} className={styles["corpus-list-item"]}>
                            <p className='per4 start'>{el?.company_number}</p>
                            <p className='per4'>{el?.company_unit ? el?.company_unit.unit_number : ""}</p>
                            <p className='per4'>{el?.company_battalion ? el?.company_battalion.battalion_number : ""}</p>
                            <div className='per4 end flex justify-end'>
                                <button className={`btn cursor-pointer`} onClick={() => chnageCompany(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                <button className={`btn cursor-pointer`} onClick={() => deleteCompany(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                            </div>
                        </li>
                })}
            </ol>}
            
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
